import { render } from "./ImportModule.vue?vue&type=template&id=39607ec2&scoped=true"
import script from "./ImportModule.vue?vue&type=script&lang=js"
export * from "./ImportModule.vue?vue&type=script&lang=js"

import "./ImportModule.vue?vue&type=style&index=0&id=39607ec2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39607ec2"]])

export default __exports__